<template>
  <div class="table-cell">
    <el-table
    :data="table_data">
      <el-table-column label="报警等级" prop="alarmLevel" width="50">
        <template slot-scope="scope">
          <span :class="['alarm-level',scope.row.alarmLevel=='1'?'first-lv':(scope.row.alarmLevel=='2'?'second-lv':'')]">{{scope.row.alarmLevel}}</span>
        </template>
      </el-table-column>
      <el-table-column label="报警分类" prop="alarmCategoryName" width="80"></el-table-column>
      <el-table-column label="分部" prop="divisionName" width="80"></el-table-column>
      <el-table-column label="设备名称" prop="deviceAssetNumber" width="80"></el-table-column>
      <el-table-column label="设备类型" prop="deviceTypeName" width="80"></el-table-column>
      <el-table-column label="报警描述" prop="alarmDescription" width="75"></el-table-column>
      <el-table-column label="报警图像" prop="alarmImageUri" width="90">
        <template slot-scope="scope">
          <img :src="rootUrl + scope.row.alarmImageUri" alt="" width="100%">
        </template>
      </el-table-column>
      <el-table-column label="报警时间" prop="createdAt" width="150"></el-table-column>
      <el-table-column label="报警值" prop="alarmValue" width="80"></el-table-column>
      <el-table-column label="正常值" prop="alarmThreshold" width="80"></el-table-column>
      <el-table-column label="处理状态" prop="isDeal" width="80">
        <template slot-scope="scope">
          <span v-if="scope.row.isDeal == '0'">未处理</span>
          <span v-if="scope.row.isDeal == '1'">已处理</span>
        </template>
      </el-table-column>
      <el-table-column label="处理人" prop="nickName" width="50"></el-table-column>
      <el-table-column label="处理时间" prop="confirm_time" width="80"></el-table-column>
    </el-table>
  </div>
</template>

<script>
  import {getSession} from "../../assets/js/tools/instruments";

  export default {
name: "printAlarm",
  data(){
    return{
      table_data: [],
      area: "",
      category: "",
      device_type: "",
      device_num: "",
      page_size: "",
      currentPage: "",
      date_from: "",
      date_end: "",
      status: "",
    }
  },
  mounted() {
    this.getTableData()
  },
  methods:{
    getTableData(){
     let temp = getSession('printData').split(',');
     let arr = [temp[0], temp[1],temp[2], temp[3],temp[4], temp[5],temp[6], temp[7],temp[8]];
        this.$get('alarmmanagement/getdata', arr).then((response)=>{
          this.table_data = response.data;
          setTimeout(function (){
            this.print()
          },500)
        })
    },
    print(){
      window.print()
    }
  }
}
</script>

<style scoped lang="scss">
 .table-cell{
   width: 1060px;
   margin: 0 auto;
 }
</style>